import { ALLOW_EDIT } from '../../../utils/OperationPermissions';

const SalesTransactionEnquiry = {
  type: 'MinMaxCalculationParametersInput', //Not sure why - Brought over from SalesReconciliationForm.js to avoid breaking it.
  formTitle: 'Sales Ledger Reconciliation',
  formUrl: '/Customers/Reconciliation/',
  screenReference: 'SALES_LEDGER_RECONCILIATION',
  operations: ALLOW_EDIT,
};

export default SalesTransactionEnquiry;
